module.exports = __webpack_public_path__ + "img/my-collect-select.0f9df349.svg";